import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './components/sidebar.component';
import { TopbarComponent } from './components/topbar.component';
import { DefaultComponent } from '../pages/default/default.component';
import { LayoutComponent } from './components/layout.component';
import { LayoutService } from './services/layout.service';
import { SharedModule }  from 'src/app/shared.module';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { SkynetixAssistantComponent } from './components/skynetix-assistant/skynetix-assistant.component';
import { SkynetixAssistantService } from './components/skynetix-assistant/skynetix-assistant.service';
import { ButtonModule,ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationsComponent } from './components/notifications.component';
import { CustomGridModule } from '../pages/default/custom-grid/custom-grid.module';
import { LeftbarComponent } from './components/leftbar.component';
import { ChatService } from '../pages/default/chat/services/chat.service';
import { ConfirmDialogComponent } from './components/confirm-dialog.component';
import { ConfirmDialogService } from './services/confirm-dialog.component';
import { DebutyComponent } from './components/deputy.component';
import { DebutyListComponent } from './components/deputy-list.component';
import { EmailNotificationComponent } from './components/email-notification.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { MenusModule } from "@progress/kendo-angular-menu";
import { FilterPipe } from './pipes/filter.pipe';
import { TooltipModule } from 'src/app/common/tooltip/tooltip.module';


@NgModule({
    declarations: [
        SidebarComponent,
        LeftbarComponent,
        TopbarComponent,
        DefaultComponent,
        LayoutComponent,
        NotificationsComponent,
        DebutyComponent,
        DebutyListComponent,
        ConfirmDialogComponent,
        EmailNotificationComponent,
        FilterPipe,
        SkynetixAssistantComponent
    ],
    exports: [
        SidebarComponent,
        LeftbarComponent,
        TopbarComponent,
        DefaultComponent,
        LayoutComponent,
        SkynetixAssistantComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        CustomGridModule,
        SharedModule,
        DialogModule,
        WindowModule,
        ButtonModule,
        ButtonsModule,
        DateInputsModule,
        InputsModule,
        DropDownsModule,
        EditorModule,
        MenusModule,
        TooltipModule
    ],
    providers: [
        LayoutService,
        ChatService,
        ConfirmDialogService,
        SkynetixAssistantService
    ]
})
export class LayoutModule {
}
